import { render } from "./mobile-footer-nav.vue?vue&type=template&id=b6ff1ee2&scoped=true&ts=true"
import script from "./mobile-footer-nav.vue?vue&type=script&lang=ts"
export * from "./mobile-footer-nav.vue?vue&type=script&lang=ts"

import "./mobile-footer-nav.vue?vue&type=style&index=0&id=b6ff1ee2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6ff1ee2"]])

export default __exports__